// extracted by mini-css-extract-plugin
export default {"Scheduled":"Collections_Scheduled__xwoG2"};